

import { dateHelper } from '@/helpers/dateHelper'
import foHeader from '@/components/header/header.vue'
import foFooter from '@/components/footer/footer.vue'
import timelineTracking from '@/components/timelineTracking/timelineTracking.vue'

import TimelineTrackingService from '@/services/timelineTacking/timelineTracking.service'

import { collectMixin } from '@/mixins'
import { SnackBarType } from '@/store/types'
import mixins from 'vue-typed-mixins'
import { StatusItemVue } from '@/types'

export default mixins(collectMixin).extend({
  name: 'mp-drive-tracking',
  components: {
    foHeader,
    foFooter,
    timelineTracking,
  },
  data() {
    return {
      selectedStatus: [] as  Array<StatusItemVue | null>,
      dateHelper,
      hasLoaded: false,
    }
  },
  async mounted() {
    try {
      const {
        query: { language }
      } = this.$route

      const languageToUse = language?.toString() || ''

      await this.getCollect(this.$route.name!, languageToUse)

      this.selectedStatus = TimelineTrackingService.getStatusCollect(this.collect!.collectStatus)
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
})
